import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Ring } from "@uiball/loaders";
import { useJsApiLoader } from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { Edit, Trash2 } from "lucide-react";
import LocationSearch from "./components/LocationSearch";
import { addToCart, setCartOpen, clearCart } from "@/redux/reducers/cartReducer";
import { getProductData, updateProduct, deleteMyProduct, CreateOrderInternal, addProductTrackingDetail, getProductInformation, addTrackingDescription, addCertificate } from "../../../utils/services/user.service";
import GalleryPRO from "./components/GalleryPRO";
import PriceCartPRO from "./components/PriceCartPRO";
import CartReal from "./components/CartReal";
import CheckoutReal from "./components/CheckoutReal";
import AuctionPRO from "./components/AuctionPRO";
import AdminPanel from "./components/AdminPanel";
import TabsPRO from "./components/TabsPRO";
import TraceabilityPROV4 from "./components/TraceabilityPROV4";
import PhaseHeader from "./components/traceability/PhaseHeader";
import TrackingEventCard from "./components/traceability/TrackingEventCard";
import TrackingHistorySidebar from "./components/traceability/TrackingHistoryModal";
import { Page, Section, SectionTitle, MiniChartBar } from "./components/shared";
import { DescriptionSidebar, CertificationSidebar, SidebarOverlay, SidebarHeader, SidebarTitle, CloseButton } from "./components/traceability/FormStyles";
import { getExplorerTxBase } from "../../../utils/blockchainExplorer";
import {
  TraceTimeline,
  TraceRail,
  TraceLine,
  TraceDot,
  TraceCard,
  DetailBox,
  SmallGhostBtn,
} from "./components/traceability/TraceabilityStyles";
import { ProductEditSidebar, FormGroup, Label, Input, ModalOverlay, ModalContainer, ModalTitle, ModalMessage, ModalActions } from "./components/AuctionStyles";
import CustomOfferModal from "../../../shared/components/customOfferModal/CustomOfferModal";
import ProductButton from "./components/ProductButton";
import { useChainContext } from "../../../containers/context/context";
import PaymentSidebar from "../../../shared/components/PaymentSidebar";
import { getTxUrl } from "../../../utils/blockchainExplorer";
import {
  ProductLayout,
  ProductColumn,
  VariantDeleteButton,
  LoadingWrapper,
  OwnerMessageBox,
  DetailsHeaderRow,
  DetailsTitle,
  DetailsButtonGroup,
  EditProductButton,
  DeleteProductButton,
  FeaturesWrapper,
  FeaturesList,
  FeatureItem,
  DocumentsList,
  DocumentItem,
  DocumentLink,
  DocumentBullet,
  DocumentIcon,
  NoDocumentsText,
  SellerScoreBarWrapper,
  SidebarHeaderRow,
  SidebarCloseButton,
  SidebarContent,
  EditTextarea,
  VatHint,
  EditSelect,
  FeatureRow,
  RemoveFeatureButton,
  AddFeatureButton,
  VariantsSection,
  VariantsSectionLabel,
  VariantFieldsColumn,
  VariantFieldLabel,
  AddVariantButton,
  VariantPlusSpan,
  CancelEditVariantButton,
  VariantsTableSection,
  VariantsCountText,
  TableScrollWrapper,
  VariantsTable,
  VariantsTableHeadRow,
  VariantsTableHeadCell,
  VariantsTableBodyRow,
  VariantsTableCell,
  VariantsTableActionCell,
  ActionCellInner,
  VariantEditButton,
  IconSmall,
  SidebarFooterRow,
  UpdateProductButton,
  CancelSidebarButton,
  AdminInput,
  ModalCancelButton,
  ModalDeleteButton,
} from "./ProductDetails.styles";

export default function ProductDetails() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { socket } = useChainContext();
  const searchParams = new URLSearchParams(location.search);
  const productId = searchParams.get('id') || location.pathname.split("/").pop();

  const cart = useSelector((state) => state.cart.items);
  const cartOpen = useSelector((state) => state.cart.isOpen);

  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState(null);
  console.log("🚀 ~ ProductDetails ~ productData:", productData)
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [cartCheckoutOpen, setCartCheckoutOpen] = useState(false);
  const [buyNowPaymentOpen, setBuyNowPaymentOpen] = useState(false);
  const [buyNowItem, setBuyNowItem] = useState(null);
  const cartItems = useSelector((state) => state.cart?.items ?? []);
  const [adminOpen, setAdminOpen] = useState(false);
  const [adminMode, setAdminMode] = useState(false);
  const [showCustomOfferModal, setShowCustomOfferModal] = useState(false);
  const [SelectedColor, setSelectedColor] = useState(null);

  const [productName, setProductName] = useState("");
  const [unitPrice, setUnitPrice] = useState(0);
  const [activeTab, setActiveTab] = useState("details");
  const [brand, setBrand] = useState("");
  const [condition, setCondition] = useState("New");
  const [sku, setSku] = useState("");
  const [sellerName, setSellerName] = useState("");
  const [sellerScore, setSellerScore] = useState(96);
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isUpdatingProduct, setIsUpdatingProduct] = useState(false);
  const [showProductEditSidebar, setShowProductEditSidebar] = useState(false);
  const [expandedLots, setExpandedLots] = useState({});
  const [lotTrackingForms, setLotTrackingForms] = useState({}); // Track which lot's tracking form is open
  const [lotTrackingDetails, setLotTrackingDetails] = useState({}); // Track details for each lot: { lotId: [] }
  const [lotTrackingFormData, setLotTrackingFormData] = useState({}); // Form data for each lot: { lotId: { title, description, batch_number, location } }
  const [lotTrackingImages, setLotTrackingImages] = useState({}); // Images for each lot: { lotId: [] }
  const [lotTrackingDocuments, setLotTrackingDocuments] = useState({}); // Documents for each lot: { lotId: [] }
  const [lotTrackingCoordinates, setLotTrackingCoordinates] = useState({}); // Coordinates for each lot: { lotId: { lat, lng } }
  const [lotTrackingLocationData, setLotTrackingLocationData] = useState({}); // Location data for each lot: { lotId: { location } }
  const [isSubmittingLotTracking, setIsSubmittingLotTracking] = useState({}); // Loading state for each lot: { lotId: boolean }
  const [isLoadingLotTracking, setIsLoadingLotTracking] = useState({}); // Loading state for fetching: { lotId: boolean }
  const [lotTrackingExpanded, setLotTrackingExpanded] = useState({}); // Expanded events per lot: { lotId: { eventId: boolean } }
  const [lotDescriptionSidebars, setLotDescriptionSidebars] = useState({}); // Description sidebars per lot: { lotId: boolean }
  const [lotCertificationSidebars, setLotCertificationSidebars] = useState({}); // Certification sidebars per lot: { lotId: boolean }
  const [lotSelectedRecordIds, setLotSelectedRecordIds] = useState({}); // Selected record IDs per lot: { lotId: recordId }
  const [lotDescriptionFormData, setLotDescriptionFormData] = useState({}); // Description form data per lot: { lotId: { description, location } }
  const [lotDescriptionFiles, setLotDescriptionFiles] = useState({}); // Description files per lot: { lotId: [] }
  const [lotDescriptionLocationData, setLotDescriptionLocationData] = useState({}); // Description location data per lot
  const [lotDescriptionCoordinates, setLotDescriptionCoordinates] = useState({}); // Description coordinates per lot
  const [lotCertificationFormData, setLotCertificationFormData] = useState({}); // Certification form data per lot: { lotId: { title, description, location } }
  const [lotCertificationFiles, setLotCertificationFiles] = useState({}); // Certification files per lot: { lotId: [] }
  const [lotCertificationLocationData, setLotCertificationLocationData] = useState({}); // Certification location data per lot
  const [lotCertificationCoordinates, setLotCertificationCoordinates] = useState({}); // Certification coordinates per lot
  const [lotTrackingHistory, setLotTrackingHistory] = useState({}); // Tracking history per lot: { lotId: { descriptions: [], certificates: [] } }
  const [lotHistoryModals, setLotHistoryModals] = useState({}); // History modals per lot: { lotId: boolean }
  const [lotSelectedRecordForHistory, setLotSelectedRecordForHistory] = useState({}); // Selected record for history per lot: { lotId: recordId }
  const [isSubmittingLotDescription, setIsSubmittingLotDescription] = useState({}); // Loading state for description per lot
  const [isSubmittingLotCertification, setIsSubmittingLotCertification] = useState({}); // Loading state for certification per lot
  const [isLoadingLotHistory, setIsLoadingLotHistory] = useState({}); // Loading state for history per lot

  // Google Maps API loader - reuse the same loader as TraceabilityPROV4
  const { isLoaded: isMapLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyCYx6E7TSAHDQMFB41DNksmX7v3zXaKt5Y',
    libraries: ['places'],
    id: 'traceability-maps-loader',
  });
  const [productEditForm, setProductEditForm] = useState({
    title: "",
    brand: "",
    description: "",
    deliveryCharges: 0,
    subcategory_id: "",
    pickupAddress: "",
    warrantyInMonths: 0,
    product_condition: "New",
    custom_offer_status: false,
    pre_order_status: false,
    features: [],
    product_sizes_quantity: [],
    vat: "",
    selectedLotIds: [],
    lotVariants: {}, // Store price and quantity for each selected lot: { lotId: { price: "", quantity: "" } }
  });
  const [variantForm, setVariantForm] = useState({
    price: "",
    year: "",
    quantity: "",
  });
  const [editingVariantIndex, setEditingVariantIndex] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem('storeSessioId')) {
      const sessionIdValue = Math.random().toString(36).substring(2, 15);
      localStorage.setItem('storeSessioId', sessionIdValue);
    }
  }, []);

  const fetchProductData = useCallback(async () => {
    if (!productId) {
      toast.error('Product ID is missing');
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const sessionId = localStorage.getItem('storeSessioId') || Math.random().toString(36).substring(2, 15);
      const payload = {
        productId: productId,
        session_id: sessionId,
      };

      const response = await getProductData(payload);

      if (response.data?.success && response.data?.productDetails?.[0]) {
        const raw = response.data.productDetails[0];
        // Use deliveryCharges from getProductInformation API (support both camelCase and snake_case)
        const deliveryCharges = Number(raw.deliveryCharges ?? raw.delivery_charges ?? 0);
        const product = { ...raw, deliveryCharges };
        setProductData(product);

        setProductName(product.title || 'Untitled Product');
        setUnitPrice(product.product_sizes_quantity?.[0]?.price || product.euro_price?.[0] || 0);
        setBrand(product.brand || '');
        setCondition(product.product_condition || 'New');
        setSku(product._id || '');
        setSellerName(product.seller_name?.[0]?.name || product.seller_wallet?.name || 'Unknown Seller');
        setSellerScore(96);
      } else {
        toast.error('Product not found');
        history.push('/products');
      }
    } catch (error) {
      toast.error(error.response?.data?.Message || 'Failed to load product details');
    } finally {
      setIsLoading(false);
    }
  }, [productId, history]);

  useEffect(() => {
    fetchProductData();
  }, [fetchProductData]);

  const images = productData?.pictures || [];

  // Use lot_info for displaying lot info
  const lotInfo = (productData?.lot_info_for_edit && Array.isArray(productData.lot_info_for_edit)) ? productData.lot_info_for_edit : [];
  console.log("🚀 ~ ProductDetails ~ lotInfo:", lotInfo)

  // Fetch tracking details for each lot using getProductTrackingInfo API
  const fetchLotTrackingDetails = async (lotId) => {
    if (!lotId || !productId) return;
    try {
      setIsLoadingLotTracking(prev => ({ ...prev, [lotId]: true }));
      // Use getProductTrackingInfo API with lot_id parameter
      const payload = { 
        limit: '1000000', 
        page_number: 1, 
        product_id: productId, 
        lot_id: lotId 
      };
      // getProductInformation internally calls getProductTrackingInfo API
      const response = await getProductInformation(payload);
      if (response?.data?.success || response?.data?.data) {
        const trackingData = response.data.data || response.data.trackingDetails || [];
        // Filter to only show lot tracking items (status === "lot")
        const filteredTracking = Array.isArray(trackingData) 
          ? trackingData.filter(item => item.status === "lot")
          : [];
        setLotTrackingDetails(prev => ({ ...prev, [lotId]: filteredTracking }));
      } else {
        setLotTrackingDetails(prev => ({ ...prev, [lotId]: [] }));
      }
    } catch (error) {
      console.error("Error fetching lot tracking details:", error);
      setLotTrackingDetails(prev => ({ ...prev, [lotId]: [] }));
    } finally {
      setIsLoadingLotTracking(prev => ({ ...prev, [lotId]: false }));
    }
  };

  // Fetch tracking details for all lots when lotInfo changes
  useEffect(() => {
    if (lotInfo.length > 0 && productId) {
      lotInfo.forEach((lot) => {
        const lotId = lot._id;
        if (lotId) {
          fetchLotTrackingDetails(lotId);
        }
      });
    }
  }, [lotInfo, productId]);

  // Helper functions for lot tracking
  const txBase = getExplorerTxBase('BNB');

  const phaseMeta = {
    Mint: { icon: '🧬', hint: 'Tokenization & genesis record' },
    QC: { icon: '🧪', hint: 'Verification & quality checks' },
    Vault: { icon: '🧊', hint: 'Custody / storage events' },
    Transfer: { icon: '🔁', hint: 'Ownership / logistics / settlement' },
  };

  const parseLocation = (locationArray) => {
    if (!locationArray || !Array.isArray(locationArray) || locationArray.length === 0) return null;
    try {
      const locationStr = locationArray[0];
      const locationObj = typeof locationStr === 'string' ? JSON.parse(locationStr) : locationStr;
      return { lat: locationObj.lat, lng: locationObj.lng };
    } catch (error) {
      console.error("Error parsing location:", error);
      return null;
    }
  };

  const mapLotTrackingToEvents = (details, lotId) => {
    if (!Array.isArray(details) || details.length === 0) return [];
    return details.map((detail, index) => {
      let phase = 'Transfer';
      const titleLower = (detail.title || '').toLowerCase();
      if (titleLower.includes('mint') || titleLower.includes('genesis') || titleLower.includes('tokenize')) {
        phase = 'Mint';
      } else if (titleLower.includes('quality') || titleLower.includes('qc') || titleLower.includes('verify') || titleLower.includes('check')) {
        phase = 'QC';
      } else if (titleLower.includes('vault') || titleLower.includes('storage') || titleLower.includes('custody')) {
        phase = 'Vault';
      }
      let status = 'info';
      if (titleLower.includes('pass') || titleLower.includes('confirm') || titleLower.includes('complete')) {
        status = 'ok';
      } else if (titleLower.includes('pending') || titleLower.includes('wait')) {
        status = 'pending';
      }
      return {
        id: detail._id || `event-${lotId}-${index}`,
        phase,
        date: detail.createdAt || new Date().toISOString(),
        title: detail.title || `Tracking Event ${index + 1}`,
        status,
        actor: detail.origin || 'System',
        location: detail.location ? (typeof detail.location === 'string' ? detail.location : JSON.parse(detail.location[0])?.location || 'Unknown') : 'Unknown',
        tx: detail.hash || null,
        detail: detail.description || '',
        batch_number: detail.batch_number || '',
        images: detail.images || [],
        documents: detail.documents || [],
        coordinates: parseLocation(detail.location),
        rawData: detail,
      };
    });
  };

  // Handlers for lot tracking description
  const handleLotAddDescription = async (lotId, e) => {
    e.preventDefault();
    const formData = lotDescriptionFormData[lotId] || {};
    if (!formData.description?.trim()) {
      toast.error("Please enter a description");
      return;
    }
    const recordId = lotSelectedRecordIds[lotId];
    if (!recordId) {
      toast.error("No record selected");
      return;
    }
    try {
      setIsSubmittingLotDescription(prev => ({ ...prev, [lotId]: true }));
      const submitFormData = new FormData();
      submitFormData.append("record_id", recordId);
      submitFormData.append("status", "lot");
      submitFormData.append("location", lotDescriptionLocationData[lotId]?.location || formData.location || "");
      submitFormData.append("description", formData.description);
      const files = lotDescriptionFiles[lotId] || [];
      files.forEach((file) => submitFormData.append("File", file));
      const res = await addTrackingDescription(submitFormData);
      toast.success(res?.data?.Message || "Tracking description added successfully!");
      setLotDescriptionFormData(prev => ({ ...prev, [lotId]: { description: "", location: "" } }));
      setLotDescriptionFiles(prev => ({ ...prev, [lotId]: [] }));
      setLotDescriptionLocationData(prev => ({ ...prev, [lotId]: null }));
      setLotDescriptionCoordinates(prev => ({ ...prev, [lotId]: null }));
      setLotDescriptionSidebars(prev => ({ ...prev, [lotId]: false }));
      setLotSelectedRecordIds(prev => ({ ...prev, [lotId]: null }));
      await fetchLotTrackingDetails(lotId);
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong!");
    } finally {
      setIsSubmittingLotDescription(prev => ({ ...prev, [lotId]: false }));
    }
  };

  // Handlers for lot tracking certification
  const handleLotAddCertification = async (lotId, e) => {
    e.preventDefault();
    const formData = lotCertificationFormData[lotId] || {};
    if (!formData.title?.trim()) {
      toast.error("Please enter a certificate name");
      return;
    }
    const files = lotCertificationFiles[lotId] || [];
    if (files.length === 0) {
      toast.error("Please select at least one certification file");
      return;
    }
    const recordId = lotSelectedRecordIds[lotId];
    if (!recordId) {
      toast.error("No record selected");
      return;
    }
    try {
      setIsSubmittingLotCertification(prev => ({ ...prev, [lotId]: true }));
      const submitFormData = new FormData();
      submitFormData.append("record_id", recordId);
      submitFormData.append("status", "lot");
      submitFormData.append("certificate_name", formData.title);
      submitFormData.append("location", lotCertificationLocationData[lotId]?.location || formData.location || "");
      files.forEach((file) => submitFormData.append("File", file));
      const res = await addCertificate(submitFormData);
      if (res.status === 200) {
        toast.success("Certification data added successfully!");
      } else {
        toast.error("Failed to add certification data.");
      }
      setLotCertificationFiles(prev => ({ ...prev, [lotId]: [] }));
      setLotCertificationFormData(prev => ({ ...prev, [lotId]: { title: "", description: "", location: "" } }));
      setLotCertificationLocationData(prev => ({ ...prev, [lotId]: null }));
      setLotCertificationCoordinates(prev => ({ ...prev, [lotId]: null }));
      setLotCertificationSidebars(prev => ({ ...prev, [lotId]: false }));
      setLotSelectedRecordIds(prev => ({ ...prev, [lotId]: null }));
      await fetchLotTrackingDetails(lotId);
    } catch (error) {
      console.error("Error uploading certification:", error);
      toast.error(error?.response?.data?.Message || "An error occurred while uploading certification.");
    } finally {
      setIsSubmittingLotCertification(prev => ({ ...prev, [lotId]: false }));
    }
  };

  // Handler for lot tracking history
  const fetchLotTrackingHistory = async (lotId, recordId) => {
    if (!recordId || !productId) return;
    try {
      setIsLoadingLotHistory(prev => ({ ...prev, [lotId]: true }));
      const payload = { limit: '1000000', page_number: 1, product_id: productId, lot_id: lotId };
      const response = await getProductInformation(payload);
      if (response?.data?.success || response?.data?.data) {
        const trackingData = response.data.data || response.data.trackingDetails || [];
        const selectedRecord = trackingData.find(record => record._id === recordId);
        if (selectedRecord) {
          const descriptions = Array.isArray(selectedRecord.tracking_history)
            ? selectedRecord.tracking_history.filter(item => item.type === 'description' || !item.certificate_name)
            : [];
          const certificates = Array.isArray(selectedRecord.tracking_history)
            ? selectedRecord.tracking_history.filter(item => item.certificate_name)
            : [];
          setLotTrackingHistory(prev => ({ ...prev, [lotId]: { descriptions, certificates } }));
        } else {
          setLotTrackingHistory(prev => ({ ...prev, [lotId]: { descriptions: [], certificates: [] } }));
        }
      } else {
        setLotTrackingHistory(prev => ({ ...prev, [lotId]: { descriptions: [], certificates: [] } }));
      }
    } catch (error) {
      console.error("Error fetching lot tracking history:", error);
      toast.error("Failed to load tracking history");
      setLotTrackingHistory(prev => ({ ...prev, [lotId]: { descriptions: [], certificates: [] } }));
    } finally {
      setIsLoadingLotHistory(prev => ({ ...prev, [lotId]: false }));
    }
  };

  const handleLotViewHistory = async (lotId, recordId) => {
    setLotSelectedRecordForHistory(prev => ({ ...prev, [lotId]: recordId }));
    setLotHistoryModals(prev => ({ ...prev, [lotId]: true }));
    await fetchLotTrackingHistory(lotId, recordId);
  };

  // Check if product has an active auction - filter to only include auctions where end time has not passed
  const now = Date.now();
  const activeAuctions = productData?.active_auction?.filter(auction => {
    const endTime = auction?.acution_end_time || auction?.auction_end_time;
    if (!endTime) return false;
    const endDate = new Date(endTime).getTime();
    return endDate > now; // Only include if end time is in the future
  }) || [];
  const activeAuction = activeAuctions[0] || null;
  const auctionTiers = activeAuction?.auction_tier || [];
  const hasActiveAuction = activeAuction && auctionTiers.length > 0;

  // Check if product is in an active group (end_time hasn't passed)
  const activeGroups = productData?.group_status?.filter(group => {
    if (!group?.end_time) return false;
    const endDate = new Date(group.end_time).getTime();
    return endDate > now; // Only include if end time is in the future
  }) || [];
  const activeGroup = activeGroups[0] || null;
  const hasActiveGroup = !!activeGroup;

  // Check if current user is the product owner
  const isProductOwner = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const currentUserId = user?.data?.user?.user_id || user?.data?.user?._id;
      const productUserId = productData?.userId || productData?.current_owner?.[0]?.current_owner_id;
      return currentUserId && productUserId && String(currentUserId) === String(productUserId);
    } catch (error) {
      console.error("Error checking product owner:", error);
      return false;
    }
  };

  const handleAddToCart = (qty = 1, variant = null) => {
    if (hasActiveAuction) {
      toast.warning('Cannot add to cart while auction is active. Please participate in the auction instead.');
      return;
    }

    const lotProduction = variant?.lot_number && Array.isArray(variant.production)
      ? variant.production[0]
      : null;

    const itemPrice = variant
      ? (variant.lot_number
          ? (lotProduction?.price ?? variant.price ?? unitPrice)
          : (variant.price ?? unitPrice))
      : unitPrice;
    const variantId = variant?._id || null;
    const variantColor = variant?.color || null;
    const itemName = variant
      ? (variant.lot_number
          ? `Lot #${variant.lot_number}`
          : `${productName} (${variant.color})`)
      : productName;
    const itemImage = productData?.pictures?.[0] || productData?.image || productData?.product_image || productData?.coverImage || null;
    const availableQty = variant
      ? (variant.lot_number
          ? (lotProduction?.quantity ?? variant.quantity ?? productData?.product_sizes_quantity?.[0]?.quantity ?? 999)
          : (variant.quantity ?? productData?.product_sizes_quantity?.[0]?.quantity ?? 999))
      : (productData?.product_sizes_quantity?.[0]?.quantity ?? 999);

    dispatch(addToCart({
      name: itemName,
      baseProductName: productName,
      price: itemPrice,
      qty,
      productId: productData._id,
      variantId,
      variantColor,
      variant,
      variants: productData?.product_sizes_quantity || [],
      image: itemImage,
      availableQty,
      deliveryCharges: productData?.deliveryCharges,
      vat: productData?.vat ?? 0,
      productSnapshot: {
        seller_wallet: productData?.seller_wallet?.address ?? productData?.seller_wallet,
        store_id: productData?.store_id ?? productData?.userId,
        category_id: productData?.category_id,
        symbol: productData?.symbol,
        chain_id: productData?.chain_id,
        approver_wallet_Address: productData?.approver_wallet_Address ?? productData?.approver_wallet_address,
        buyer_approver_address: productData?.buyer_approver_address,
        agency_percentage: productData?.agency_percentage,
      },
    }));
    dispatch(setCartOpen(true));
  };

  const handleBuyNow = (qty = 1, variant = null) => {
    if (hasActiveAuction) {
      toast.warning('Cannot buy now while auction is active. Please participate in the auction instead.');
      return;
    }

    const itemPrice = variant?.price ?? unitPrice;
    const itemName = variant ? `${productName} (${variant.color})` : productName;
    setBuyNowItem({
      quantity: qty,
      unitPrice: itemPrice,
      productId: productData._id,
      productName: itemName,
      productData,
      variant,
    });
    setBuyNowPaymentOpen(true);
  };

  const cartPaymentProps = useMemo(() => {
    if (!cartItems.length) return { orderDetail: [], products: [], shippingCost: 0, categoryId: null, symbol: 'USDT' };
    const orderDetail = cartItems.map((i) => ({
      product_id: i.productId,
      quantity: i.qty,
      price: i.price,
      vat: i.vat,
    }));
    const products = cartItems.map((i) => ({
      id: i.productId,
      _id: i.productId,
      name: i.name,
      title: i.name,
      price: i.price,
      vat: i.vat,
      image: i.image,
      pictures: i.image ? [i.image] : [],
      product_image: i.image,
      coverImage: i.image,
    }));
    const shippingCost = cartItems.reduce((s, i) => s + Number(i.deliveryCharges ?? 0), 0) || 25;
    const first = cartItems[0];
    const snap = first?.productSnapshot;
    return {
      orderDetail,
      products,
      shippingCost,
      categoryId: snap?.category_id ?? null,
      symbol: snap?.symbol ?? 'USDT',
    };
  }, [cartItems]);

  const handleCartCheckoutPay = useCallback(async (deliveryInfo, symbol, summary) => {
    const items = cartItems.filter((i) => i.productSnapshot);
    if (!items.length) {
      toast.error('Some cart items cannot be checked out. Remove and re-add them from the product page.');
      return;
    }
    const first = items[0];
    const snap = first.productSnapshot;
    const product_details = items.map((i) => ({
      product_id: i.productId,
      quantity: i.qty,
      price: i.price,
      title: i.name,
      delivery_charges: Number(i.deliveryCharges ?? 0),
      vat: i.vat ?? 0,
      ...(i.variant?._id ? { detail_objectId: i.variant._id } : {}),
    }));
    const total_amount = summary?.totalAmount ?? 0;
    const total_quantity = items.reduce((s, i) => s + i.qty, 0);
    const total_delivery_charges = items.reduce((s, i) => s + Number(i.deliveryCharges ?? 0), 0);
    await CreateOrderInternal({
      seller_wallet: snap.seller_wallet,
      agency_percentage: snap.agency_percentage ?? 0,
      buyer_approver_address: snap.buyer_approver_address ?? '',
      sale_tax: summary?.saleTax ?? 0,
      total_quantity,
      store_id: snap.store_id,
      category_id: snap.category_id,
      total_amount,
      product_id: items.map((i) => i.productId),
      delivery_country: deliveryInfo.deliveryCountry,
      delivery_address: deliveryInfo.deliveryAddress,
      second_delivery_address: deliveryInfo.secondDeliveryAddress || '',
      approver_wallet_Address: snap.approver_wallet_Address ?? '',
      chain_id: snap.chain_id,
      symbol: symbol || snap.symbol || 'USDT',
      total_delivery_charges,
      product_details,
      phone_number: deliveryInfo.phoneNumber,
    });
    dispatch(clearCart());
  }, [cartItems, dispatch]);

  const handleBuyNowPay = useCallback(async (deliveryInfo, symbol, summary) => {
    if (!buyNowItem) return;
    const pd = buyNowItem.productData;
    const totalDeliveryCharges = Number(pd?.deliveryCharges ?? 0);
    const totalAmount = summary?.totalAmount ?? (buyNowItem.quantity * buyNowItem.unitPrice + totalDeliveryCharges + (summary?.saleTax ?? 0));
    const detail_objectId = buyNowItem.variant?._id ?? pd?.product_sizes_quantity?.[0]?._id;

    const product_details = [{
      product_id: buyNowItem.productId,
      quantity: buyNowItem.quantity,
      price: buyNowItem.unitPrice,
      title: buyNowItem.productName,
      delivery_charges: totalDeliveryCharges,
      vat: pd?.vat ?? 0,
      ...(detail_objectId ? { detail_objectId } : {}),
    }];

    await CreateOrderInternal({
      seller_wallet: pd?.seller_wallet?.address ?? pd?.seller_wallet,
      agency_percentage: pd?.agency_percentage ?? 0,
      buyer_approver_address: pd?.buyer_approver_address ?? '',
      sale_tax: summary?.saleTax ?? 0,
      total_quantity: buyNowItem.quantity,
      store_id: pd?.store_id ?? pd?.userId,
      category_id: pd?.category_id,
      total_amount: totalAmount,
      product_id: [buyNowItem.productId],
      delivery_country: deliveryInfo.deliveryCountry,
      delivery_address: deliveryInfo.deliveryAddress,
      second_delivery_address: deliveryInfo.secondDeliveryAddress || '',
      approver_wallet_Address: pd?.approver_wallet_Address ?? pd?.approver_wallet_address ?? '',
      chain_id: pd?.chain_id,
      symbol: symbol || pd?.symbol || 'USDT',
      total_delivery_charges: totalDeliveryCharges,
      product_details,
      phone_number: deliveryInfo.phoneNumber,
    });
  }, [buyNowItem]);

  const handleChatWithOwner = () => {
    if (!productData?.userId) {
      toast.error('Product owner information is not available');
      return;
    }

    if (!socket) {
      toast.error('Chat service is not available. Please try again later.');
      return;
    }

    try {
      const currentUserId = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
      if (!currentUserId) {
        toast.error('Please login to chat with the owner');
        return;
      }

      const sellerName = productData.seller_wallet?.name || productData.seller_name?.[0]?.name || 'Product Owner';
      const sellerUserId = productData.userId;

      // Emit startChat to initialize the chat
      socket.emit(
        "startChat",
        {
          subject: "Start New One to One Chat",
          user_id: currentUserId,
          user_id_2: sellerUserId,
          type: "user",
        },
        (response) => {
          // Response handling if needed
        }
      );

      // Navigate to livechat with userId and name parameters
      // The Chat component will handle the chat initialization when it receives these params
      history.push(`/livechat?userId=${sellerUserId}&name=${encodeURIComponent(sellerName)}`);
    } catch (error) {
      console.error("Error starting chat:", error);
      toast.error('Failed to start chat. Please try again.');
    }
  };

  const handleEditProduct = () => {
    if (!productData?._id) {
      toast.error("Product data is missing");
      return;
    }
    // Pre-populate form with current product data
    const featuresArray = productData.features 
      ? (Array.isArray(productData.features) ? productData.features : (typeof productData.features === 'string' ? JSON.parse(productData.features) : []))
      : [];

    // Pre-select lot variants that already have price/quantity defined
    let initialSelectedLotIds = [];
    let initialLotVariants = {};
    if (Array.isArray(productData.product_sizes_quantity)) {
      productData.product_sizes_quantity.forEach((v) => {
        if (v.lot_id && (v.price != null || v.quantity != null)) {
          initialSelectedLotIds.push(v.lot_id);
          initialLotVariants[v.lot_id] = {
            price: v.price != null ? v.price.toString() : "",
            quantity: v.quantity != null ? v.quantity.toString() : "",
          };
        }
      });
    }
    // Ensure unique IDs
    initialSelectedLotIds = [...new Set(initialSelectedLotIds)];

    const cleanedProductSizesQuantity = (productData.product_sizes_quantity || []).map((variant) => {
      // For lot variants, remove lot_details and only keep reference fields
      if (variant.isLotVariant || variant.lot_id || variant.lot_number) {
        const { lot_details, ...cleanVariant } = variant;
        return cleanVariant;
      }
      // For regular variants, remove lot_details if present
      if (variant.lot_details) {
        const { lot_details, ...cleanVariant } = variant;
        return cleanVariant;
      }
      return variant;
    });

    setProductEditForm({
      title: productData.title || productName || "",
      brand: productData.brand || brand || "",
      description: productData.description || "",
      deliveryCharges: productData.deliveryCharges || 0,
      subcategory_id: productData.subcategory_id || "",
      pickupAddress: productData.pickupAddress || "",
      warrantyInMonths: productData.warrantyInMonths || productData.warranty || 0,
      product_condition: productData.product_condition || condition || "New",
      custom_offer_status: productData.custom_offer_status || false,
      pre_order_status: productData.pre_order_status || false,
      features: featuresArray,
      product_sizes_quantity: cleanedProductSizesQuantity,
      vat: productData.vat || 0,
      selectedLotIds: initialSelectedLotIds,
      lotVariants: initialLotVariants,
    });
    setShowProductEditSidebar(true);
  };

  const handleUpdateProduct = async () => {
    if (!productData?._id) {
      toast.error("Product data is missing");
      return;
    }

    if (!productEditForm.title || productEditForm.title.trim() === "") {
      toast.error("Please enter a product title");
      return;
    }

    setIsUpdatingProduct(true);
    try {
      const formData = new FormData();
      
      // Match the exact payload structure from updateProduct
      formData.append('pickupAddress', productEditForm.pickupAddress || '');
      formData.append('warrantyInMonths', productEditForm.warrantyInMonths || 0);
      formData.append('title', productEditForm.title);
      formData.append('brand', productEditForm.brand || '');
      formData.append('deliveryCharges', productEditForm.deliveryCharges || 0);
      formData.append('vat', productEditForm.vat || 0);
      
      // Include product_sizes_quantity from form
      // Filter out lot variants completely - they should only be in lot_info, not in product_sizes_quantity
      let cleanedProductSizesQuantity = [];
      if (productEditForm.product_sizes_quantity && productEditForm.product_sizes_quantity.length > 0) {
        cleanedProductSizesQuantity = productEditForm.product_sizes_quantity
          .filter((variant) => {
            // Exclude lot variants (they will be sent in lot_info instead)
            return !(variant.isLotVariant || variant.lot_id || variant.lot_number);
          })
          .map((variant) => {
            // For regular variants, remove lot_details if present
            if (variant.lot_details) {
              const { lot_details, ...cleanVariant } = variant;
              return cleanVariant;
            }
            return variant;
          });
        
        if (cleanedProductSizesQuantity.length > 0) {
          formData.append('product_sizes_quantity', JSON.stringify(cleanedProductSizesQuantity));
        }
      } else if (productData.product_sizes_quantity) {
        // Clean existing product data as well - filter out lot variants
        cleanedProductSizesQuantity = productData.product_sizes_quantity
          .filter((variant) => {
            // Exclude lot variants
            return !(variant.isLotVariant || variant.lot_id || variant.lot_number);
          })
          .map((variant) => {
            // For regular variants, remove lot_details if present
            if (variant.lot_details) {
              const { lot_details, ...cleanVariant } = variant;
              return cleanVariant;
            }
            return variant;
          });
        
        if (cleanedProductSizesQuantity.length > 0) {
          formData.append('product_sizes_quantity', JSON.stringify(cleanedProductSizesQuantity));
        }
      }
      
      formData.append('description', productEditForm.description || '');
      
      // Include features from form
      const featuresArray = productEditForm.features.filter(f => f && f.trim() !== '');
      formData.append('features', JSON.stringify(featuresArray));
      
      // Include subcategory_id from form
      if (productEditForm.subcategory_id) {
        formData.append('subcategory_id', productEditForm.subcategory_id);
      } else if (productData.subcategory_id) {
        formData.append('subcategory_id', productData.subcategory_id);
      }
      
      // Include product_condition from form
      formData.append('product_condition', productEditForm.product_condition || 'New');
      
      // Include custom_offer_status from form (only if pre_order_status is false)
      if (!productEditForm.pre_order_status) {
        formData.append('custom_offer_status', productEditForm.custom_offer_status || false);
      }
      
      // Include pre_order_status from form
      formData.append('pre_order_status', productEditForm.pre_order_status || false);

      // Include lot_info for selected lot variants in the format:
      // lot_info: [{ id, quantity, price }]
      if (productEditForm.selectedLotIds && productEditForm.selectedLotIds.length > 0) {
        const lotInfoPayload = productEditForm.selectedLotIds
          .map((lotId) => {
            const lotVariant = productEditForm.lotVariants?.[lotId] || {};
            const quantityNum =
              lotVariant.quantity !== undefined && lotVariant.quantity !== ""
                ? Number(lotVariant.quantity)
                : 0;
            const priceNum =
              lotVariant.price !== undefined && lotVariant.price !== ""
                ? Number(lotVariant.price)
                : 0;

            return {
              id: lotId,
              quantity: quantityNum,
              price: priceNum,
            };
          })
          // Keep only lots that have at least one of quantity / price set
          .filter((item) => item.quantity > 0 || item.price > 0);

        if (lotInfoPayload.length > 0) {
          formData.append("lot_info", JSON.stringify(lotInfoPayload));
        }
      }
      
      // Use productId (not product_id) as shown in the payload example
      formData.append('productId', productData._id);
      
      // Preserve existing seller_wallet
      if (productData.seller_wallet) {
        formData.append('seller_wallet', productData.seller_wallet);
      } else if (productData.seller_name && Array.isArray(productData.seller_name) && productData.seller_name[0]?.address) {
        formData.append('seller_wallet', productData.seller_name[0].address);
      }
      
      // Preserve existing agency_percentage
      if (productData.agency_percentage !== undefined) {
        formData.append('agency_percentage', productData.agency_percentage);
      }
      
      // Preserve existing store_type
      if (productData.store_type) {
        formData.append('store_type', productData.store_type);
      }
      
      const response = await updateProduct(formData);

      if (response.data?.success || response.data?.status || response.data?.Message) {
        toast.success(response.data?.Message || response.data?.message || "Product updated successfully!");
        setShowProductEditSidebar(false);
        // Refresh product data using the existing fetchProductData function
        await fetchProductData();
      } else {
        toast.error(response.data?.Message || response.data?.message || "Failed to update product");
      }
    } catch (error) {
      toast.error(error.response?.data?.Message || error.response?.data?.message || error.message || "Failed to update product");
    } finally {
      setIsUpdatingProduct(false);
    }
  };

  const handleDeleteProduct = () => {
    setShowDeleteModal(true);
  };

  const confirmDeleteProduct = () => {
    if (!productData?._id) {
      toast.error("Product data is missing");
      setShowDeleteModal(false);
      return;
    }

    setIsDeletingProduct(true);
    deleteMyProduct({ product_id: productData._id })
      .then((response) => {
        if (response.data?.success || response.data?.status || response.data?.Message) {
          toast.success(response.data?.Message || response.data?.message || "Product deleted successfully!");
          setShowDeleteModal(false);
          // Go back to previous page
          history.goBack();
        } else {
          toast.error(response.data?.Message || response.data?.message || "Failed to delete product");
          setIsDeletingProduct(false);
          setShowDeleteModal(false);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.Message || error.response?.data?.message || error.message || "Failed to delete product");
        setIsDeletingProduct(false);
        setShowDeleteModal(false);
      });
  };


  if (isLoading) {
    return (
      <Page>
        <LoadingWrapper>
          <Ring size={65} color="#00f7d2" />
        </LoadingWrapper>
      </Page>
    );
  }

  if (!productData) {
    return (
      <Page>
        <SectionTitle>Product Not Found</SectionTitle>
        <Section>
          <p>The product you're looking for doesn't exist or has been removed.</p>
        </Section>
      </Page>
    );
  }

  return (
    <Page>
      <AdminPanel
        open={adminOpen}
        setOpen={setAdminOpen}
        adminMode={adminMode}
        setAdminMode={setAdminMode}
      />

      <SectionTitle>{productName}</SectionTitle>

      <ProductLayout>
        <ProductColumn>
          <GalleryPRO images={images} />
        </ProductColumn>

        <ProductColumn>
          <PriceCartPRO
            price={unitPrice}
            onAddToCart={handleAddToCart}
            onBuyNow={handleBuyNow}
            productData={productData}
            hasActiveAuction={hasActiveAuction}
            hasActiveGroup={hasActiveGroup}
            activeGroupId={activeGroup?._id}
            showCustomOffer={productData?.custom_offer_status}
            onCustomOfferClick={() => setShowCustomOfferModal(true)}
            showChatWithOwner={productData?.userId && !isProductOwner()}
            onChatWithOwnerClick={handleChatWithOwner}
            productName={productName}
            showPurchaseButtons={!isProductOwner()}
          />
          {productData?.userId && isProductOwner() && (
            <OwnerMessageBox>
              <i className="fa fa-info-circle" aria-hidden="true" />
              <span>This product belongs to you, so you cannot chat with the owner.</span>
            </OwnerMessageBox>
          )}
        </ProductColumn>
      </ProductLayout>
      <Section className="mt-4">
        <TabsPRO activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === "details" && (
          <div>
            <DetailsHeaderRow>
              <DetailsTitle>Product Details</DetailsTitle>
              {isProductOwner() && (
                <DetailsButtonGroup>
                  <EditProductButton onClick={handleEditProduct} title="Edit Product">
                    <Edit size={16} />
                    Edit Product
                  </EditProductButton>
                  <DeleteProductButton
                    onClick={handleDeleteProduct}
                    disabled={isDeletingProduct}
                    $disabled={isDeletingProduct}
                    title="Delete Product"
                  >
                    <Trash2 size={16} />
                    {isDeletingProduct ? "Deleting..." : "Delete Product"}
                  </DeleteProductButton>
                </DetailsButtonGroup>
              )}
            </DetailsHeaderRow>
            <p>
              <strong>Name:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
              ) : (
                productName
              )}
            </p>
            <p>
              <strong>Brand:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                />
              ) : (
                brand
              )}
            </p>
            <p>
              <strong>Condition:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  value={condition}
                  onChange={(e) => setCondition(e.target.value)}
                />
              ) : (
                condition
              )}
            </p>
            <p>
              <strong>SKU:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  value={sku}
                  onChange={(e) => setSku(e.target.value)}
                />
              ) : (
                sku
              )}
            </p>
            {productData?.features && productData.features.length > 0 && (
              <FeaturesWrapper>
                <strong>Features:</strong>
                <FeaturesList>
                  {productData.features.map((feature, index) => (
                    <FeatureItem key={index}>{feature}</FeatureItem>
                  ))}
                </FeaturesList>
              </FeaturesWrapper>
            )}
          </div>
        )}
        {activeTab === "documents" && (
          <div>
            <h3>Documents</h3>
            {productData?.product_document && productData.product_document.length > 0 ? (
              <DocumentsList>
                {productData.product_document.map((doc, index) => (
                  <DocumentItem key={index}>
                    <DocumentLink href={doc} target="_blank" rel="noopener noreferrer">
                      <DocumentBullet>•</DocumentBullet>
                      <span>Document {index + 1}</span>
                      <DocumentIcon>
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                      </DocumentIcon>
                    </DocumentLink>
                  </DocumentItem>
                ))}
              </DocumentsList>
            ) : (
              <NoDocumentsText>No documents available for this product.</NoDocumentsText>
            )}
          </div>
        )}
        {activeTab === "trace" && (
          <div>
            <DetailsHeaderRow>
              <DetailsTitle>Lot Info</DetailsTitle>
            </DetailsHeaderRow>
            {lotInfo.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {lotInfo.map((lot, index) => {
                  const compliance = lot.compliance?.[0] || {};
                  const production = lot.production?.[0] || {};
                  const lotId = lot._id || index;
                  const isExpanded = expandedLots[lotId] || false;
                  
                  const productionDate = production.production_date
                    ? new Date(production.production_date).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )
                    : "—";
                  const expiryDate = production.expiry_date
                    ? new Date(production.expiry_date).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )
                    : "—";
                  
                  const quantityDisplay =
                    production && production.quantity !== undefined && production.quantity !== null
                      ? production.quantity
                      : "—";
                  const priceDisplay =
                    production && production.price !== undefined && production.price !== null
                      ? (typeof production.price === "number"
                          ? `${production.price} ${productData?.symbol || "USDT"}`
                          : production.price)
                      : "—";

                  const shortHash = (h) => {
                    if (!h) return '—';
                    if (h.length <= 5) return h;
                    return `${h.slice(0, 3)}...${h.slice(-2)}`;
                  };

                  return (
                    <TraceCard key={lotId}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                        <div>
                          <strong style={{ color: '#e5e7eb', fontSize: 15 }}>Lot #{lot.lot_number}</strong>
                          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
                            {expiryDate} · {lot.hash ? (
                              <a
                                href={getTxUrl("BNB", lot.hash)}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  fontSize: 12,
                                  opacity: 0.85,
                                  border: '1px solid #1f2937',
                                  borderRadius: 999,
                                  padding: '4px 10px',
                                  background: 'rgba(17,21,34,0.55)',
                                  color: '#00f7d2',
                                  textDecoration: 'none',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  fontFamily: 'monospace',
                                  marginLeft: 8,
                                }}
                              >
                                TX: {shortHash(String(lot.hash))}
                                <FontAwesomeIcon icon={faExternalLinkAlt} size={12} style={{ opacity: 0.8 }} />
                              </a>
                            ) : '—'}
                          </div>
                        </div>

                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                          <SmallGhostBtn onClick={() => setExpandedLots(prev => ({ ...prev, [lotId]: !isExpanded }))}>
                            {isExpanded ? 'Hide' : 'Details'}
                          </SmallGhostBtn>
                        </div>
                      </div>

                      {isExpanded && (
                        <DetailBox>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                            <div>
                              <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>GTIN</div>
                              <div style={{ fontWeight: 900, color: '#5ce9ff' }}>{lot.global_trade_item_number || '—'}</div>
                            </div>
                            <div>
                              <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>Created</div>
                              <div style={{ fontWeight: 900, color: '#5ce9ff' }}>
                                {new Date(lot.createdAt).toLocaleDateString("en-GB")}
                              </div>
                            </div>
                          </div>

                          {production.manufacturing_batch_number && (
                            <div style={{ marginTop: 10 }}>
                              <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>Batch Number</div>
                              <div style={{ fontWeight: 700, color: '#e5e7eb' }}>{production.manufacturing_batch_number}</div>
                            </div>
                          )}

                          <div style={{ marginTop: 10 }}>
                            <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 8 }}>Production</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Production Date:</strong> {productionDate}
                              </div>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Expiry Date:</strong> {expiryDate}
                              </div>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Quantity:</strong> {quantityDisplay}
                              </div>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Price:</strong> {priceDisplay}
                              </div>
                            </div>
                          </div>

                          <div style={{ marginTop: 10 }}>
                            <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 8 }}>Compliance & Storage</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Min Temperature:</strong>{" "}
                                {compliance.minimum_validated_storage_temperature !== undefined
                                  ? `${compliance.minimum_validated_storage_temperature}°C`
                                  : "—"}
                              </div>
                              <div>
                                <strong style={{ color: '#94a3b8' }}>Max Temperature:</strong>{" "}
                                {compliance.maximum_validated_storage_temperature !== undefined
                                  ? `${compliance.maximum_validated_storage_temperature}°C`
                                  : "—"}
                              </div>
                            </div>
                          </div>

                          {lot.hash && (
                            <div style={{ marginTop: 10, fontSize: 12, opacity: 0.85, display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>Full TX:</span>
                              <a
                                href={getTxUrl("BNB", lot.hash)}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: '#00f7d2',
                                  fontWeight: 900,
                                  textDecoration: 'none',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  fontFamily: 'monospace'
                                }}
                              >
                                {shortHash(String(lot.hash))}
                                <FontAwesomeIcon icon={faExternalLinkAlt} size={14} style={{ opacity: 0.8 }} />
                              </a>
                            </div>
                          )}

                          {lot.documents && lot.documents.length > 0 && (
                            <div style={{ marginTop: 12 }}>
                              <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 8 }}>Documents</div>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {lot.documents.map((document, docIndex) => (
                                  <a
                                    key={docIndex}
                                    href={document}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                      padding: '10px 12px',
                                      borderRadius: 8,
                                      background: 'rgba(255, 255, 255, 0.05)',
                                      border: '1px solid #1f2937',
                                      textDecoration: 'none',
                                      color: '#e5e7eb',
                                      transition: 'all 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = 'rgba(0, 247, 210, 0.1)';
                                      e.currentTarget.style.borderColor = '#00f7d2';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                      e.currentTarget.style.borderColor = '#1f2937';
                                    }}
                                  >
                                    <span style={{ fontSize: 20 }}>📄</span>
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontSize: 14, fontWeight: 500 }}>Document {docIndex + 1}</div>
                                      <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>Click to open</div>
                                    </div>
                                    <span style={{ color: '#00f7d2', fontSize: 18 }}>→</span>
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                        </DetailBox>
                      )}

                      {/* Lot Tracking Section */}
                      <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid #1f2937' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
                          <h4 style={{ margin: 0, fontSize: 16, color: '#e5e7eb' }}>Traceability PRO</h4>
                          {isProductOwner() && (
                            <button
                              onClick={() => setLotTrackingForms(prev => ({ ...prev, [lotId]: !prev[lotId] }))}
                              style={{
                                padding: "8px 16px",
                                borderRadius: 10,
                                background: lotTrackingForms[lotId] ? "#1f2937" : "linear-gradient(90deg, #00f7d2, #5ce9ff)",
                                color: lotTrackingForms[lotId] ? "#9ca3af" : "#000",
                                fontWeight: 600,
                                fontSize: 14,
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              {lotTrackingForms[lotId] ? "Cancel" : "Add Tracking Detail"}
                            </button>
                          )}
                        </div>

                        {isLoadingLotTracking[lotId] ? (
                          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                            <Ring size={40} color="#00f7d2" />
                          </div>
                        ) : (() => {
                          const events = mapLotTrackingToEvents(lotTrackingDetails[lotId] || [], lotId);
                          return events.length > 0 ? (
                            events.map((e, eventIndex) => {
                              const isExpanded = lotTrackingExpanded[lotId]?.[e.id] || false;
                              return (
                                <div key={e.id} style={{ marginBottom: 10 }}>
                                  <PhaseHeader
                                    icon={phaseMeta[e.phase]?.icon || '📦'}
                                    title={e.title || e.phase || 'Tracking Event'}
                                    hint={e?.detail || 'Tracking record'}
                                    eventCount={1}
                                    onExpand={() => setLotTrackingExpanded(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), [e.id]: true }
                                    }))}
                                    onCollapse={() => setLotTrackingExpanded(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), [e.id]: false }
                                    }))}
                                  />
                                  <TrackingEventCard
                                    event={e}
                                    isLast={eventIndex === events.length - 1}
                                    isExpanded={isExpanded}
                                    isProductOwner={isProductOwner()}
                                    isMapLoaded={isMapLoaded}
                                    txBase={txBase}
                                    onToggle={() => setLotTrackingExpanded(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), [e.id]: !isExpanded }
                                    }))}
                                    onViewHistory={() => handleLotViewHistory(lotId, e.id)}
                                    onAddDescription={() => {
                                      setLotSelectedRecordIds(prev => ({ ...prev, [lotId]: e.id }));
                                      setLotDescriptionSidebars(prev => ({ ...prev, [lotId]: true }));
                                    }}
                                    onAddCertification={() => {
                                      setLotSelectedRecordIds(prev => ({ ...prev, [lotId]: e.id }));
                                      setLotCertificationSidebars(prev => ({ ...prev, [lotId]: true }));
                                    }}
                                  />
                                </div>
                              );
                            })
                          ) : (
                            <p style={{ opacity: 0.75, fontSize: 14, color: '#9ca3af' }}>No tracking records found.</p>
                          );
                        })()}

                        {lotTrackingForms[lotId] && isProductOwner() && (
                          <div style={{
                            marginTop: 20,
                            padding: '20px',
                            borderRadius: 12,
                            background: 'rgba(15, 23, 42, 0.8)',
                            border: '1px solid #1f2937',
                          }}>
                            <h4 style={{ margin: "0 0 20px 0", color: "#e5e7eb", fontSize: 16 }}>Add Tracking Detail</h4>
                            <form onSubmit={(e) => {
                              e.preventDefault();
                              const formData = lotTrackingFormData[lotId] || {};
                              if (!formData.title || !formData.description || !formData.batch_number) {
                                toast.error("Please fill all required fields");
                                return;
                              }
                              const images = lotTrackingImages[lotId] || [];
                              if (images.length === 0) {
                                toast.error("Please add at least one image");
                                return;
                              }
                              const coordinates = lotTrackingCoordinates[lotId];
                              if (!coordinates) {
                                toast.error("Please enter location coordinates");
                                return;
                              }
                              
                              const trackingFormData = new FormData();
                              trackingFormData.append("product_id", productId);
                              trackingFormData.append("lot_id", lot._id);
                              trackingFormData.append("status", "lot");
                              trackingFormData.append("title", formData.title);
                              trackingFormData.append("description", formData.description);
                              trackingFormData.append("origin", lotTrackingLocationData[lotId]?.location || formData.location || '');
                              trackingFormData.append("batch_number", formData.batch_number);
                              trackingFormData.append("location", JSON.stringify(coordinates));
                              images.forEach((image) => trackingFormData.append("File", image));
                              const docs = lotTrackingDocuments[lotId] || [];
                              docs.forEach((document) => trackingFormData.append("File2", document));
                              
                              setIsSubmittingLotTracking(prev => ({ ...prev, [lotId]: true }));
                              addProductTrackingDetail(trackingFormData)
                                .then((res) => {
                                  toast.success(res?.data?.Message || "Tracking detail added successfully!");
                                  setLotTrackingFormData(prev => ({ ...prev, [lotId]: { title: "", description: "", batch_number: "", location: "" } }));
                                  setLotTrackingImages(prev => ({ ...prev, [lotId]: [] }));
                                  setLotTrackingDocuments(prev => ({ ...prev, [lotId]: [] }));
                                  setLotTrackingCoordinates(prev => ({ ...prev, [lotId]: null }));
                                  setLotTrackingLocationData(prev => ({ ...prev, [lotId]: null }));
                                  setLotTrackingForms(prev => ({ ...prev, [lotId]: false }));
                                  // Refresh tracking details
                                  fetchLotTrackingDetails(lot._id);
                                })
                                .catch((error) => {
                                  toast.error(error?.response?.data?.Message || "Something went wrong!");
                                })
                                .finally(() => {
                                  setIsSubmittingLotTracking(prev => ({ ...prev, [lotId]: false }));
                                });
                            }}>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Title *</label>
                                <input
                                  type="text"
                                  value={lotTrackingFormData[lotId]?.title || ''}
                                  onChange={(e) => setLotTrackingFormData(prev => ({
                                    ...prev,
                                    [lotId]: { ...(prev[lotId] || {}), title: e.target.value }
                                  }))}
                                  placeholder="Enter tracking title"
                                  required
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Description *</label>
                                <textarea
                                  value={lotTrackingFormData[lotId]?.description || ''}
                                  onChange={(e) => setLotTrackingFormData(prev => ({
                                    ...prev,
                                    [lotId]: { ...(prev[lotId] || {}), description: e.target.value }
                                  }))}
                                  placeholder="Enter tracking description"
                                  required
                                  rows={4}
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                    resize: 'vertical',
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Batch Number *</label>
                                <input
                                  type="text"
                                  value={lotTrackingFormData[lotId]?.batch_number || ''}
                                  onChange={(e) => setLotTrackingFormData(prev => ({
                                    ...prev,
                                    [lotId]: { ...(prev[lotId] || {}), batch_number: e.target.value }
                                  }))}
                                  placeholder="Enter batch number"
                                  required
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Location *</label>
                                <LocationSearch
                                  onCoordinatesChange={({ location, coordinates }) => {
                                    setLotTrackingLocationData(prev => ({
                                      ...prev,
                                      [lotId]: { location }
                                    }));
                                    setLotTrackingCoordinates(prev => ({
                                      ...prev,
                                      [lotId]: coordinates
                                    }));
                                    setLotTrackingFormData(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), location: location || '' }
                                    }));
                                  }}
                                  required
                                  isGoogleMapsLoaded={isMapLoaded}
                                />
                                {lotTrackingCoordinates[lotId] && (
                                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>
                                    Coordinates: {lotTrackingCoordinates[lotId].lat?.toFixed(6)}, {lotTrackingCoordinates[lotId].lng?.toFixed(6)}
                                  </div>
                                )}
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Images *</label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  multiple
                                  onChange={(e) => setLotTrackingImages(prev => ({
                                    ...prev,
                                    [lotId]: Array.from(e.target.files || [])
                                  }))}
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                                {lotTrackingImages[lotId]?.length > 0 && (
                                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 6 }}>
                                    {lotTrackingImages[lotId].length} file(s) selected
                                  </div>
                                )}
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Documents</label>
                                <input
                                  type="file"
                                  accept=".pdf,.doc,.docx,.txt"
                                  multiple
                                  onChange={(e) => setLotTrackingDocuments(prev => ({
                                    ...prev,
                                    [lotId]: Array.from(e.target.files || [])
                                  }))}
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                                {lotTrackingDocuments[lotId]?.length > 0 && (
                                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 6 }}>
                                    {lotTrackingDocuments[lotId].length} file(s) selected
                                  </div>
                                )}
                              </div>
                              <button
                                type="submit"
                                disabled={isSubmittingLotTracking[lotId]}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  borderRadius: 8,
                                  background: isSubmittingLotTracking[lotId] ? '#1f2937' : 'linear-gradient(90deg, #00f7d2, #5ce9ff)',
                                  color: isSubmittingLotTracking[lotId] ? '#9ca3af' : '#000',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  border: 'none',
                                  cursor: isSubmittingLotTracking[lotId] ? 'not-allowed' : 'pointer',
                                }}
                              >
                                {isSubmittingLotTracking[lotId] ? "Submitting..." : "Submit Tracking Detail"}
                              </button>
                            </form>
                          </div>
                        )}

                        {/* Description Sidebar for Lot */}
                        <SidebarOverlay 
                          show={lotDescriptionSidebars[lotId]} 
                          onClick={() => setLotDescriptionSidebars(prev => ({ ...prev, [lotId]: false }))} 
                        />
                        <DescriptionSidebar open={lotDescriptionSidebars[lotId]}>
                          <SidebarHeader>
                            <SidebarTitle>Add Tracking Description</SidebarTitle>
                            <CloseButton onClick={() => setLotDescriptionSidebars(prev => ({ ...prev, [lotId]: false }))}>×</CloseButton>
                          </SidebarHeader>
                          <form onSubmit={(e) => handleLotAddDescription(lotId, e)}>
                            <div style={{ padding: '20px' }}>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Description *</label>
                                <textarea
                                  value={lotDescriptionFormData[lotId]?.description || ''}
                                  onChange={(e) => setLotDescriptionFormData(prev => ({
                                    ...prev,
                                    [lotId]: { ...(prev[lotId] || {}), description: e.target.value }
                                  }))}
                                  placeholder="Enter description"
                                  required
                                  rows={6}
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                    resize: 'vertical',
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Location</label>
                                <LocationSearch
                                  onCoordinatesChange={({ location, coordinates }) => {
                                    setLotDescriptionLocationData(prev => ({ ...prev, [lotId]: { location } }));
                                    setLotDescriptionCoordinates(prev => ({ ...prev, [lotId]: coordinates }));
                                    setLotDescriptionFormData(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), location: location || '' }
                                    }));
                                  }}
                                  isGoogleMapsLoaded={isMapLoaded}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Files</label>
                                <input
                                  type="file"
                                  multiple
                                  onChange={(e) => setLotDescriptionFiles(prev => ({
                                    ...prev,
                                    [lotId]: Array.from(e.target.files || [])
                                  }))}
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                              </div>
                              <button
                                type="submit"
                                disabled={isSubmittingLotDescription[lotId]}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  borderRadius: 8,
                                  background: isSubmittingLotDescription[lotId] ? '#1f2937' : 'linear-gradient(90deg, #00f7d2, #5ce9ff)',
                                  color: isSubmittingLotDescription[lotId] ? '#9ca3af' : '#000',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  border: 'none',
                                  cursor: isSubmittingLotDescription[lotId] ? 'not-allowed' : 'pointer',
                                }}
                              >
                                {isSubmittingLotDescription[lotId] ? "Submitting..." : "Submit"}
                              </button>
                            </div>
                          </form>
                        </DescriptionSidebar>

                        {/* Certification Sidebar for Lot */}
                        <SidebarOverlay 
                          show={lotCertificationSidebars[lotId]} 
                          onClick={() => setLotCertificationSidebars(prev => ({ ...prev, [lotId]: false }))} 
                        />
                        <CertificationSidebar open={lotCertificationSidebars[lotId]}>
                          <SidebarHeader>
                            <SidebarTitle>Add Certification</SidebarTitle>
                            <CloseButton onClick={() => setLotCertificationSidebars(prev => ({ ...prev, [lotId]: false }))}>×</CloseButton>
                          </SidebarHeader>
                          <form onSubmit={(e) => handleLotAddCertification(lotId, e)}>
                            <div style={{ padding: '20px' }}>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Certificate Name *</label>
                                <input
                                  type="text"
                                  value={lotCertificationFormData[lotId]?.title || ''}
                                  onChange={(e) => setLotCertificationFormData(prev => ({
                                    ...prev,
                                    [lotId]: { ...(prev[lotId] || {}), title: e.target.value }
                                  }))}
                                  placeholder="Enter certificate name"
                                  required
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Location</label>
                                <LocationSearch
                                  onCoordinatesChange={({ location, coordinates }) => {
                                    setLotCertificationLocationData(prev => ({ ...prev, [lotId]: { location } }));
                                    setLotCertificationCoordinates(prev => ({ ...prev, [lotId]: coordinates }));
                                    setLotCertificationFormData(prev => ({
                                      ...prev,
                                      [lotId]: { ...(prev[lotId] || {}), location: location || '' }
                                    }));
                                  }}
                                  isGoogleMapsLoaded={isMapLoaded}
                                />
                              </div>
                              <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginBottom: 6 }}>Certification Files *</label>
                                <input
                                  type="file"
                                  multiple
                                  onChange={(e) => setLotCertificationFiles(prev => ({
                                    ...prev,
                                    [lotId]: Array.from(e.target.files || [])
                                  }))}
                                  required
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: 8,
                                    background: '#0d1220',
                                    border: '1px solid #1f2937',
                                    color: '#e5e7eb',
                                    fontSize: 14,
                                  }}
                                />
                              </div>
                              <button
                                type="submit"
                                disabled={isSubmittingLotCertification[lotId]}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  borderRadius: 8,
                                  background: isSubmittingLotCertification[lotId] ? '#1f2937' : 'linear-gradient(90deg, #00f7d2, #5ce9ff)',
                                  color: isSubmittingLotCertification[lotId] ? '#9ca3af' : '#000',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  border: 'none',
                                  cursor: isSubmittingLotCertification[lotId] ? 'not-allowed' : 'pointer',
                                }}
                              >
                                {isSubmittingLotCertification[lotId] ? "Submitting..." : "Submit"}
                              </button>
                            </div>
                          </form>
                        </CertificationSidebar>

                        {/* Tracking History Sidebar for Lot */}
                        <SidebarOverlay 
                          show={lotHistoryModals[lotId]} 
                          onClick={() => setLotHistoryModals(prev => ({ ...prev, [lotId]: false }))} 
                        />
                        {lotHistoryModals[lotId] && (
                          <TrackingHistorySidebar
                            isOpen={lotHistoryModals[lotId]}
                            onClose={() => setLotHistoryModals(prev => ({ ...prev, [lotId]: false }))}
                            trackingHistory={lotTrackingHistory[lotId] || { descriptions: [], certificates: [] }}
                            isLoading={isLoadingLotHistory[lotId]}
                          />
                        )}
                      </div>
                    </TraceCard>
                  );
                })}
              </div>
            ) : (
              <div
                style={{
                  marginTop: "20px",
                  color: "#94a3b8",
                  fontSize: "14px",
                }}
              >
                No lot information available for this product.
              </div>
            )}

            <div style={{ marginTop: 32 }}>
              <TraceabilityPROV4
                productId={productId}
                productData={productData}
              />
            </div>
          </div>
        )}
        {activeTab === "seller" && (
          <div>
            <h3>Seller</h3>
            <p>
              <strong>Name:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  value={sellerName}
                  onChange={(e) => setSellerName(e.target.value)}
                />
              ) : (
                sellerName
              )}
            </p>
            <p>
              <strong>Trust Score:</strong>{" "}
              {adminMode ? (
                <AdminInput
                  type="number"
                  value={sellerScore}
                  onChange={(e) =>
                    setSellerScore(
                      Math.max(0, Math.min(100, Number(e.target.value) || 0))
                    )
                  }
                />
              ) : (
                `${sellerScore}/100`
              )}
            </p>
            <SellerScoreBarWrapper>
              <MiniChartBar style={{ width: `${sellerScore}%` }} />
            </SellerScoreBarWrapper>
          </div>
        )}
        {activeTab === "reviews" && (
          <div>
            <h3>Reviews</h3>
            <p>No reviews yet. Be the first to review this product.</p>
          </div>
        )}
      </Section>



      <AuctionPRO productData={productData} onProductDataUpdate={fetchProductData} />

      <ProductEditSidebar open={showProductEditSidebar}>
        <SidebarHeaderRow>
          <SidebarTitle>Edit Product</SidebarTitle>
          <SidebarCloseButton
            type="button"
            onClick={() => {
              setShowProductEditSidebar(false);
              setProductEditForm({
                title: "",
                brand: "",
                description: "",
                deliveryCharges: 0,
                subcategory_id: "",
                pickupAddress: "",
                warrantyInMonths: 0,
                product_condition: "New",
                custom_offer_status: false,
                pre_order_status: false,
                features: [],
                product_sizes_quantity: [],
                vat: "",
                selectedLotIds: [],
                lotVariants: {},
              });
            }}
          >
            ×
          </SidebarCloseButton>
        </SidebarHeaderRow>

        <SidebarContent>
          <FormGroup>
            <Label>Product Title *</Label>
            <Input
              type="text"
              value={productEditForm.title}
              onChange={(e) => setProductEditForm({ ...productEditForm, title: e.target.value })}
              placeholder="Product title"
            />
          </FormGroup>

          <FormGroup>
            <Label>Brand *</Label>
            <Input
              type="text"
              value={productEditForm.brand}
              onChange={(e) => setProductEditForm({ ...productEditForm, brand: e.target.value })}
              placeholder="Brand name"
            />
          </FormGroup>

          <FormGroup>
            <Label>Description *</Label>
            <EditTextarea
              className="description"
              value={productEditForm.description}
              onChange={(e) => setProductEditForm({ ...productEditForm, description: e.target.value })}
              placeholder="Product description"
            />
          </FormGroup>

          <FormGroup>
            <Label>Subcategory *</Label>
            <Input
              type="text"
              value={productEditForm.subcategory_id}
              onChange={(e) => setProductEditForm({ ...productEditForm, subcategory_id: e.target.value })}
              placeholder="Select Subcategory"
            />
          </FormGroup>

          <FormGroup>
            <Label>Delivery Charges *</Label>
            <Input
              type="number"
              value={productEditForm.deliveryCharges}
              onChange={(e) => setProductEditForm({ ...productEditForm, deliveryCharges: parseFloat(e.target.value) || 0 })}
              placeholder="0"
              min="0"
              step="0.01"
            />
          </FormGroup>

          <FormGroup>
            <Label>Pickup Address *</Label>
            <EditTextarea
              className="pickup"
              value={productEditForm.pickupAddress}
              onChange={(e) => setProductEditForm({ ...productEditForm, pickupAddress: e.target.value })}
              placeholder="Enter Pickup Address"
            />
          </FormGroup>

          <FormGroup>
            <Label>Warranty In Months *</Label>
            <Input
              type="number"
              value={productEditForm.warrantyInMonths}
              onChange={(e) => setProductEditForm({ ...productEditForm, warrantyInMonths: parseInt(e.target.value) || 0 })}
              placeholder="Enter warranty in months"
              min="0"
            />
          </FormGroup>

          <FormGroup>
            <Label>VAT (%)</Label>
            <Input
              type="number"
              value={productEditForm?.vat ?? ""}
              onChange={(e) => setProductEditForm({ ...productEditForm, vat: e.target.value === "" ? "" : parseFloat(e.target.value) })}
              placeholder="Enter VAT percentage"
              min="0"
              max="100"
              step="0.01"
            />
            <VatHint>
              Enter the VAT rate as a percentage (e.g., 22 for 22%)
            </VatHint>
          </FormGroup>

          <FormGroup>
            <Label>Condition *</Label>
            <EditSelect
              value={productEditForm.product_condition}
              onChange={(e) => setProductEditForm({ ...productEditForm, product_condition: e.target.value })}
            >
              <option value="New">New</option>
              <option value="Used">Used</option>
              <option value="Never worn">Never worn</option>
              <option value="Very good condition ">Very good condition</option>
              <option value="Good condition ">Good condition</option>
              <option value="Fair condition">Fair condition</option>
            </EditSelect>
          </FormGroup>

          <FormGroup>
            <Label>Custom Offer Status</Label>
            <EditSelect
              value={productEditForm.custom_offer_status ? "true" : "false"}
              onChange={(e) => setProductEditForm({ ...productEditForm, custom_offer_status: e.target.value === "true" })}
            >
              <option value="false">False</option>
              <option value="true">True</option>
            </EditSelect>
          </FormGroup>

          <FormGroup>
            <Label>Pre Order Status</Label>
            <EditSelect
              value={productEditForm.pre_order_status ? "true" : "false"}
              onChange={(e) => setProductEditForm({ ...productEditForm, pre_order_status: e.target.value === "true" })}
            >
              <option value="false">False</option>
              <option value="true">True</option>
            </EditSelect>
          </FormGroup>

          {/* Lot Info Selection */}
          {lotInfo && lotInfo.length > 0 && (
            <FormGroup>
              <Label>Select Lot Variant</Label>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "8px" }}>
                {lotInfo.map((lot) => {
                  const compliance = lot.compliance?.[0] || {};
                  const production = lot.production?.[0] || {};
                  const productionDateObj = production.production_date
                    ? new Date(production.production_date)
                    : null;
                  const expiryDateObj = production.expiry_date
                    ? new Date(production.expiry_date)
                    : null;

                  const productionDate = productionDateObj
                    ? productionDateObj.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "—";
                  const expiryDate = expiryDateObj
                    ? expiryDateObj.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "—";

                  const now = new Date();
                  const isExpired = expiryDateObj ? expiryDateObj < now : false;
                  const isSelected = productEditForm.selectedLotIds.includes(lot._id);
                  
                  const handleLotToggle = () => {
                    if (isExpired) return;
                    const currentIds = productEditForm.selectedLotIds || [];
                    const currentLotVariants = productEditForm.lotVariants || {};
                    
                    if (isSelected) {
                      // Remove from selection
                      const newLotVariants = { ...currentLotVariants };
                      delete newLotVariants[lot._id];
                      setProductEditForm({
                        ...productEditForm,
                        selectedLotIds: currentIds.filter(id => id !== lot._id),
                        lotVariants: newLotVariants,
                      });
                    } else {
                      // Add to selection with default price and quantity from production
                      const production = lot.production?.[0] || {};
                      setProductEditForm({
                        ...productEditForm,
                        selectedLotIds: [...currentIds, lot._id],
                        lotVariants: {
                          ...currentLotVariants,
                          [lot._id]: {
                            price: production.price?.toString() || "",
                            quantity: production.quantity?.toString() || "",
                          },
                        },
                      });
                    }
                  };
                  
                  return (
                    <div
                      key={lot._id}
                      onClick={handleLotToggle}
                      style={{
                        background: isSelected
                          ? "rgba(0, 247, 210, 0.15)"
                          : "rgba(17, 21, 34, 0.8)",
                        border: isSelected
                          ? "2px solid #00f7d2"
                          : "1px solid rgba(0, 247, 210, 0.15)",
                        borderRadius: "12px",
                        padding: "16px",
                        cursor: isExpired ? "not-allowed" : "pointer",
                        opacity: isExpired ? 0.55 : 1,
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected && !isExpired) {
                          e.currentTarget.style.borderColor = "rgba(0, 247, 210, 0.4)";
                          e.currentTarget.style.background = "rgba(17, 21, 34, 0.95)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected && !isExpired) {
                          e.currentTarget.style.borderColor = "rgba(0, 247, 210, 0.15)";
                          e.currentTarget.style.background = "rgba(17, 21, 34, 0.8)";
                        }
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                        <div>
                          <div style={{ fontSize: "16px", fontWeight: 600, color: "#5ce9ff", marginBottom: "4px" }}>
                            {lot.lot_number ? `Lot #${lot.lot_number}` : "Lot"}
                            {isSelected && !isExpired && (
                              <span style={{ marginLeft: "8px", fontSize: "12px", color: "#00f7d2" }}>✓ Selected</span>
                            )}
                          </div>
                          <div style={{ fontSize: "12px", color: "#94a3b8" }}>
                            GTIN: {lot.global_trade_item_number || "—"}
                          </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6 }}>
                          {isExpired && (
                            <span
                              style={{
                                fontSize: "11px",
                                padding: "2px 8px",
                                borderRadius: "999px",
                                background: "rgba(248, 113, 113, 0.18)",
                                color: "#fecaca",
                                border: "1px solid rgba(248, 113, 113, 0.6)",
                              }}
                            >
                              Expired
                            </span>
                          )}
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "4px",
                              border: `2px solid ${
                                isSelected && !isExpired ? "#00f7d2" : "#64748b"
                              }`,
                              background:
                                isSelected && !isExpired ? "#00f7d2" : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {isSelected && !isExpired && (
                              <span
                                style={{
                                  color: "#000",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                ✓
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "12px", fontSize: "12px", color: "#cbd5e1" }}>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Batch:</strong> {production.manufacturing_batch_number || "—"}
                        </div>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Production:</strong> {productionDate}
                        </div>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Expiry:</strong> {expiryDate}
                        </div>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Quantity:</strong>{" "}
                          {typeof production.quantity === "number"
                            ? production.quantity
                            : production.quantity || "—"}
                        </div>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Price:</strong>{" "}
                          {typeof production.price === "number"
                            ? `${production.price} ${productData?.symbol || "USDT"}`
                            : production.price || "—"}
                        </div>
                        <div>
                          <strong style={{ color: "#94a3b8" }}>Temp:</strong>{" "}
                          {compliance.minimum_validated_storage_temperature !== undefined &&
                          compliance.maximum_validated_storage_temperature !== undefined
                            ? `${compliance.minimum_validated_storage_temperature}°C - ${compliance.maximum_validated_storage_temperature}°C`
                            : "—"}
                        </div>
                      </div>
                      
                      {/* Price and Quantity Inputs for Selected Lots */}
                      {isSelected && !isExpired && (
                        <div
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          style={{ 
                          marginTop: "16px", 
                          paddingTop: "16px", 
                          borderTop: "1px solid rgba(0, 247, 210, 0.2)",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px"
                        }}>
                          <div style={{ fontSize: "14px", fontWeight: 600, color: "#00f7d2", marginBottom: "8px" }}>
                            Set Price & Quantity for this Lot
                          </div>
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                            <div>
                              <Label style={{ fontSize: "12px", marginBottom: "6px", color: "#94a3b8" }}>Price *</Label>
                              <Input
                                type="number"
                                value={productEditForm.lotVariants?.[lot._id]?.price || ""}
                                onChange={(e) => {
                                  setProductEditForm({
                                    ...productEditForm,
                                    lotVariants: {
                                      ...productEditForm.lotVariants,
                                      [lot._id]: {
                                        ...productEditForm.lotVariants?.[lot._id],
                                        price: e.target.value,
                                      },
                                    },
                                  });
                                }}
                                placeholder="Enter price"
                                min="0"
                                step="0.01"
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div>
                              <Label style={{ fontSize: "12px", marginBottom: "6px", color: "#94a3b8" }}>Quantity *</Label>
                              <Input
                                type="number"
                                value={productEditForm.lotVariants?.[lot._id]?.quantity || ""}
                                onChange={(e) => {
                                  setProductEditForm({
                                    ...productEditForm,
                                    lotVariants: {
                                      ...productEditForm.lotVariants,
                                      [lot._id]: {
                                        ...productEditForm.lotVariants?.[lot._id],
                                        quantity: e.target.value,
                                      },
                                    },
                                  });
                                }}
                                placeholder="Enter quantity"
                                min="0"
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                          {(() => {
                            const existingIndex = productEditForm.product_sizes_quantity.findIndex(
                              (v) => (v.lot_id === lot._id || v.lot_number === lot.lot_number) && editingVariantIndex === null
                            );
                            const isEditingThisLot = editingVariantIndex !== null && 
                              productEditForm.product_sizes_quantity[editingVariantIndex]?.lot_id === lot._id;
                            const isUpdating = existingIndex !== -1 || isEditingThisLot;
                            
                            return (
                              <button
                                type="button"
                                onClick={() => {
                                  const lotVariant = productEditForm.lotVariants?.[lot._id];
                                  if (!lotVariant?.price || !lotVariant?.quantity) {
                                    toast.error("Please fill in both price and quantity");
                                    return;
                                  }
                                  
                                  // Check if this lot variant already exists in product_sizes_quantity
                                  const variantIndex = isEditingThisLot ? editingVariantIndex : 
                                    productEditForm.product_sizes_quantity.findIndex(
                                      (v) => v.lot_id === lot._id || v.lot_number === lot.lot_number
                                    );
                                  
                                  const newLotVariant = {
                                    price: parseFloat(lotVariant.price) || 0,
                                    year: lot.lot_number || 0, // Use lot_number as year for lot variants
                                    quantity: parseInt(lotVariant.quantity) || 0,
                                    lot_id: lot._id,
                                    lot_number: lot.lot_number,
                                    isLotVariant: true,
                                    discount_percentage: productEditForm.product_sizes_quantity[variantIndex]?.discount_percentage || 0,
                                    sold_quantity: productEditForm.product_sizes_quantity[variantIndex]?.sold_quantity || 0,
                                  };
                                  
                                  if (variantIndex !== -1) {
                                    // Update existing lot variant
                                    const updatedVariants = [...productEditForm.product_sizes_quantity];
                                    updatedVariants[variantIndex] = newLotVariant;
                                    setProductEditForm({
                                      ...productEditForm,
                                      product_sizes_quantity: updatedVariants,
                                    });
                                    toast.success("Lot variant updated successfully");
                                    setEditingVariantIndex(null);
                                  } else {
                                    // Add new lot variant
                                    setProductEditForm({
                                      ...productEditForm,
                                      product_sizes_quantity: [...(productEditForm.product_sizes_quantity || []), newLotVariant],
                                    });
                                    toast.success("Lot variant added successfully");
                                  }
                                }}
                                style={{
                                  background: "linear-gradient(135deg, #00f7d2 0%, #5ce9ff 100%)",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "10px 16px",
                                  color: "#0d1220",
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease",
                                  marginTop: "8px",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.opacity = "0.9";
                                  e.currentTarget.style.transform = "translateY(-1px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.opacity = "1";
                                  e.currentTarget.style.transform = "translateY(0)";
                                }}
                              >
                                {isUpdating ? "Update Lot Variant" : "+ Add Lot Variant"}
                              </button>
                            );
                          })()}
                          {editingVariantIndex !== null && 
                           productEditForm.product_sizes_quantity[editingVariantIndex]?.lot_id === lot._id && (
                            <button
                              type="button"
                              onClick={() => {
                                setEditingVariantIndex(null);
                                // Reset lot variant inputs to original values
                                const variant = productEditForm.product_sizes_quantity[editingVariantIndex];
                                setProductEditForm({
                                  ...productEditForm,
                                  lotVariants: {
                                    ...productEditForm.lotVariants,
                                    [lot._id]: {
                                      price: variant.price?.toString() || "",
                                      quantity: variant.quantity?.toString() || "",
                                    },
                                  },
                                });
                              }}
                              style={{
                                background: "transparent",
                                border: "1px solid #64748b",
                                borderRadius: "8px",
                                padding: "10px 16px",
                                color: "#94a3b8",
                                fontWeight: 600,
                                fontSize: "14px",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                marginTop: "8px",
                                marginLeft: "8px",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = "#94a3b8";
                                e.currentTarget.style.color = "#cbd5e1";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#64748b";
                                e.currentTarget.style.color = "#94a3b8";
                              }}
                            >
                              Cancel Edit
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </FormGroup>
          )}

          <FormGroup>
            <Label>Features *</Label>
            {productEditForm.features.map((feature, index) => (
              <FeatureRow key={index}>
                <Input
                  type="text"
                  value={typeof feature === 'string' ? feature : feature.value || feature}
                  onChange={(e) => {
                    const newFeatures = [...productEditForm.features];
                    newFeatures[index] = e.target.value;
                    setProductEditForm({ ...productEditForm, features: newFeatures });
                  }}
                  placeholder="Enter Feature"
                />
                {index > 0 && (
                  <RemoveFeatureButton
                    type="button"
                    onClick={() => {
                      const newFeatures = productEditForm.features.filter((_, i) => i !== index);
                      setProductEditForm({ ...productEditForm, features: newFeatures });
                    }}
                  >
                    Remove
                  </RemoveFeatureButton>
                )}
              </FeatureRow>
            ))}
            <AddFeatureButton
              type="button"
              onClick={() => {
                setProductEditForm({ ...productEditForm, features: [...productEditForm.features, ""] });
              }}
            >
              Add Feature
            </AddFeatureButton>
          </FormGroup>

          <VariantsSection>
            <VariantsSectionLabel>Product Variants</VariantsSectionLabel>
            
            {/* Variant Input Fields */}
            <VariantFieldsColumn>
              <FormGroup>
                <VariantFieldLabel>Price</VariantFieldLabel>
                <Input
                  type="number"
                  value={variantForm.price}
                  onChange={(e) => setVariantForm({ ...variantForm, price: e.target.value })}
                  placeholder="Enter price"
                  min="0"
                  step="0.01"
                />
              </FormGroup>

              <FormGroup>
                <VariantFieldLabel>Year</VariantFieldLabel>
                <Input
                  type="number"
                  value={variantForm.year}
                  onChange={(e) => setVariantForm({ ...variantForm, year: e.target.value })}
                  placeholder="Enter year"
                  min="1900"
                  max="2100"
                />
              </FormGroup>

              <FormGroup>
                <VariantFieldLabel>Quantity</VariantFieldLabel>
                <Input
                  type="number"
                  value={variantForm.quantity}
                  onChange={(e) => setVariantForm({ ...variantForm, quantity: e.target.value })}
                  placeholder="Enter quantity"
                  min="0"
                />
              </FormGroup>

              <AddVariantButton
                type="button"
                onClick={() => {
                  if (!variantForm.price || !variantForm.year || !variantForm.quantity) {
                    toast.error("Please fill in all fields");
                    return;
                  }
                  
                  // Check if we're editing a lot variant (should not happen here, but safety check)
                  if (editingVariantIndex !== null) {
                    const editingVariant = productEditForm.product_sizes_quantity[editingVariantIndex];
                    if (editingVariant?.isLotVariant || editingVariant?.lot_id || editingVariant?.lot_number) {
                      toast.error("Please use the lot variant section to edit lot variants");
                      return;
                    }
                  }
                  
                  const newVariant = {
                    price: parseFloat(variantForm.price) || 0,
                    year: parseInt(variantForm.year) || 0,
                    quantity: parseInt(variantForm.quantity) || 0,
                    discount_percentage: editingVariantIndex !== null && productEditForm.product_sizes_quantity[editingVariantIndex]?.discount_percentage !== undefined
                      ? productEditForm.product_sizes_quantity[editingVariantIndex].discount_percentage
                      : 0,
                    sold_quantity: editingVariantIndex !== null && productEditForm.product_sizes_quantity[editingVariantIndex]?.sold_quantity !== undefined
                      ? productEditForm.product_sizes_quantity[editingVariantIndex].sold_quantity
                      : 0,
                  };
                  
                  if (editingVariantIndex !== null) {
                    const updatedVariants = [...productEditForm.product_sizes_quantity];
                    updatedVariants[editingVariantIndex] = newVariant;
                    setProductEditForm({
                      ...productEditForm,
                      product_sizes_quantity: updatedVariants,
                    });
                    toast.success("Variant updated successfully");
                    setEditingVariantIndex(null);
                  } else {
                    setProductEditForm({
                      ...productEditForm,
                      product_sizes_quantity: [...(productEditForm.product_sizes_quantity || []), newVariant],
                    });
                    toast.success("Variant added successfully");
                  }
                  setVariantForm({ price: "", year: "", quantity: "" });
                }}
              >
                <VariantPlusSpan>+</VariantPlusSpan>
                {editingVariantIndex !== null && 
                 !productEditForm.product_sizes_quantity[editingVariantIndex]?.isLotVariant &&
                 !productEditForm.product_sizes_quantity[editingVariantIndex]?.lot_id ? "Update Variant" : "Add Product Variants"}
              </AddVariantButton>
              {editingVariantIndex !== null && 
               !productEditForm.product_sizes_quantity[editingVariantIndex]?.isLotVariant &&
               !productEditForm.product_sizes_quantity[editingVariantIndex]?.lot_id && (
                <CancelEditVariantButton
                  type="button"
                  onClick={() => {
                    setVariantForm({ price: "", year: "", quantity: "" });
                    setEditingVariantIndex(null);
                  }}
                >
                  Cancel Edit
                </CancelEditVariantButton>
              )}
            </VariantFieldsColumn>

            {/* Added Variants Table */}
            {productEditForm.product_sizes_quantity && productEditForm.product_sizes_quantity.length > 0 && (
              <VariantsTableSection>
                <VariantsCountText>
                  {productEditForm.product_sizes_quantity.length} variant{productEditForm.product_sizes_quantity.length !== 1 ? 's' : ''} added
                </VariantsCountText>
                <TableScrollWrapper>
                  <VariantsTable>
                    <thead>
                      <VariantsTableHeadRow>
                        <VariantsTableHeadCell>Price</VariantsTableHeadCell>
                        <VariantsTableHeadCell>Year / Lot #</VariantsTableHeadCell>
                        <VariantsTableHeadCell>Quantity</VariantsTableHeadCell>
                        <VariantsTableHeadCell>Action</VariantsTableHeadCell>
                      </VariantsTableHeadRow>
                    </thead>
                    <tbody>
                      {productEditForm.product_sizes_quantity.map((variant, index) => {
                        const isLotVariant = variant.isLotVariant || variant.lot_id || variant.lot_number;
                        return (
                        <VariantsTableBodyRow key={index}>
                          <VariantsTableCell>{variant.price || 0}</VariantsTableCell>
                            <VariantsTableCell>
                              {isLotVariant ? (
                                <span style={{ color: "#00f7d2", fontWeight: 600 }}>
                                  Lot #{variant.lot_number || variant.year || "—"}
                                </span>
                              ) : (
                                variant.year || 0
                              )}
                            </VariantsTableCell>
                          <VariantsTableCell>{variant.quantity || 0}</VariantsTableCell>
                          <VariantsTableActionCell>
                            <ActionCellInner>
                                {isLotVariant ? (
                                  <>
                                    <VariantEditButton
                                      type="button"
                                      onClick={() => {
                                        // For lot variants, find the lot and populate lotVariants
                                        const lot = lotInfo.find(l => l._id === variant.lot_id || l.lot_number === variant.lot_number);
                                        if (lot) {
                                          setProductEditForm({
                                            ...productEditForm,
                                            selectedLotIds: [...new Set([...(productEditForm.selectedLotIds || []), lot._id])],
                                            lotVariants: {
                                              ...productEditForm.lotVariants,
                                              [lot._id]: {
                                                price: variant.price?.toString() || "",
                                                quantity: variant.quantity?.toString() || "",
                                              },
                                            },
                                          });
                                        }
                                        setEditingVariantIndex(index);
                                      }}
                                      title="Edit"
                                    >
                                      <IconSmall as="i" className="fa fa-edit" />
                                    </VariantEditButton>
                                    <VariantDeleteButton
                                      type="button"
                                      onClick={() => {
                                        const newVariants = productEditForm.product_sizes_quantity.filter((_, i) => i !== index);
                                        const newLotVariants = { ...productEditForm.lotVariants };
                                        if (variant.lot_id) {
                                          delete newLotVariants[variant.lot_id];
                                        }
                                        setProductEditForm({ 
                                          ...productEditForm, 
                                          product_sizes_quantity: newVariants,
                                          lotVariants: newLotVariants,
                                          selectedLotIds: productEditForm.selectedLotIds.filter(id => id !== variant.lot_id),
                                        });
                                        if (editingVariantIndex === index) {
                                          setVariantForm({ price: "", year: "", quantity: "" });
                                          setEditingVariantIndex(null);
                                        }
                                        toast.success("Lot variant removed");
                                      }}
                                      title="Delete"
                                    >
                                      <IconSmall as="i" className="fa fa-trash" />
                                    </VariantDeleteButton>
                                  </>
                                ) : (
                                  <>
                              <VariantEditButton
                                type="button"
                                onClick={() => {
                                  const v = productEditForm.product_sizes_quantity[index];
                                  setVariantForm({
                                    price: v.price?.toString() || "",
                                    year: v.year?.toString() || "",
                                    quantity: v.quantity?.toString() || "",
                                  });
                                  setEditingVariantIndex(index);
                                }}
                                title="Edit"
                              >
                                <IconSmall as="i" className="fa fa-edit" />
                              </VariantEditButton>
                              <VariantDeleteButton
                                type="button"
                                onClick={() => {
                                  const newVariants = productEditForm.product_sizes_quantity.filter((_, i) => i !== index);
                                  setProductEditForm({ ...productEditForm, product_sizes_quantity: newVariants });
                                  if (editingVariantIndex === index) {
                                    setVariantForm({ price: "", year: "", quantity: "" });
                                    setEditingVariantIndex(null);
                                  }
                                  toast.success("Variant removed");
                                }}
                                title="Delete"
                              >
                                <IconSmall as="i" className="fa fa-trash" />
                              </VariantDeleteButton>
                                  </>
                                )}
                            </ActionCellInner>
                          </VariantsTableActionCell>
                        </VariantsTableBodyRow>
                        );
                      })}
                    </tbody>
                  </VariantsTable>
                </TableScrollWrapper>
              </VariantsTableSection>
            )}
          </VariantsSection>
        </SidebarContent>

        <SidebarFooterRow>
          <UpdateProductButton
            onClick={handleUpdateProduct}
            disabled={isUpdatingProduct}
            $disabled={isUpdatingProduct}
          >
            {isUpdatingProduct ? "Updating..." : "Update Product"}
          </UpdateProductButton>
          <CancelSidebarButton
            onClick={() => {
              setShowProductEditSidebar(false);
              setProductEditForm({
                title: "",
                brand: "",
                description: "",
                deliveryCharges: 0,
                subcategory_id: "",
                pickupAddress: "",
                warrantyInMonths: 0,
                product_condition: "New",
                custom_offer_status: false,
                pre_order_status: false,
                features: [],
                product_sizes_quantity: [],
                vat: "",
                selectedLotIds: [],
              });
            }}
          >
            Cancel
          </CancelSidebarButton>
        </SidebarFooterRow>
      </ProductEditSidebar>


      <CartReal
        onCheckout={() => {
          dispatch(setCartOpen(false));
          setCartCheckoutOpen(true);
        }}
      />
      <CheckoutReal
        open={checkoutOpen}
        setOpen={setCheckoutOpen}
      />

      {cartCheckoutOpen && cartItems.length > 0 && (
        <PaymentSidebar
          open={cartCheckoutOpen}
          onOpenChange={(open) => {
            setCartCheckoutOpen(open);
          }}
          mode="buy"
          title="Checkout"
          subtitle="Complete your purchase"
          productSymbol={cartPaymentProps.symbol}
          orderDetail={cartPaymentProps.orderDetail}
          products={cartPaymentProps.products}
          shippingCost={cartPaymentProps.shippingCost}
          categoryId={cartPaymentProps.categoryId}
          onBuyPay={handleCartCheckoutPay}
          onPurchaseSuccess={() => setCartCheckoutOpen(false)}
        />
      )}

      {buyNowItem && (
        <PaymentSidebar
          open={buyNowPaymentOpen}
          onOpenChange={(open) => {
            setBuyNowPaymentOpen(open);
            if (!open) setBuyNowItem(null);
          }}
          mode="buy"
          title="Checkout"
          subtitle="Complete your purchase"
          productSymbol={buyNowItem.productData?.symbol || 'USDT'}
          orderDetail={[
            {
              product_id: buyNowItem.productId,
              quantity: buyNowItem.quantity,
              price: buyNowItem.unitPrice,
              vat: buyNowItem.productData?.vat,
            },
          ]}
          products={[
            {
              id: buyNowItem.productId,
              name: buyNowItem.productName,
              title: buyNowItem.productName,
              price: buyNowItem.unitPrice,
              category_id: buyNowItem.productData?.category_id,
              vat: buyNowItem.productData?.vat,
            },
          ]}
          shippingCost={Number(buyNowItem.productData?.deliveryCharges ?? 25)}
          categoryId={buyNowItem.productData?.category_id}
          onBuyPay={handleBuyNowPay}
          onPurchaseSuccess={fetchProductData}
        />
      )}

      {/* <button
        onClick={() => setAdminOpen(true)}
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          padding: "12px 20px",
          background: "#00f7d2",
          color: "#000",
          fontWeight: 700,
          borderRadius: 12,
          cursor: "pointer",
          zIndex: 9999,
          border: "none",
        }}
      >
        Admin
      </button> */}

      {showCustomOfferModal && (
        <CustomOfferModal
          SelectedColor={SelectedColor}
          showModal={showCustomOfferModal}
          product={productData}
          closeModal={() => setShowCustomOfferModal(false)}
        />
      )}

      {/* Delete Product Confirmation Modal */}
      {showDeleteModal && (
        <ModalOverlay onClick={() => !isDeletingProduct && setShowDeleteModal(false)}>
          <ModalContainer onClick={(e) => e.stopPropagation()}>
            <ModalTitle>Delete Product</ModalTitle>
            <ModalMessage>
              Are you sure you want to delete this product? This action cannot be undone.
            </ModalMessage>
            <ModalActions>
              <ModalCancelButton
                onClick={() => setShowDeleteModal(false)}
                disabled={isDeletingProduct}
              >
                Cancel
              </ModalCancelButton>
              <ModalDeleteButton
                onClick={confirmDeleteProduct}
                disabled={isDeletingProduct}
              >
                {isDeletingProduct ? "Deleting..." : "Delete"}
              </ModalDeleteButton>
            </ModalActions>
          </ModalContainer>
        </ModalOverlay>
      )}
    </Page>
  );
}
